import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { useIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import GridItem from '../Grid/GridItem';
import Typography from '../Typography/CustomTypography';
import Button from '../Button/CustomButton';
import { RadioButtonIcon } from '../Icons/Icon';
import styles from '../../assets/jss/components/freeLogin';

import withAuthUser from '../../common/WithAuthUser';

const useStyles = makeStyles(styles);

const SeminarLogin = ({ eventInfo, customColor }) => {
    const classes = useStyles();
    const params = useParams();
    const history = useHistory();
    const intl = useIntl();

    const handleVisitorLogin = () => {
        const { shortName } = params;
        history.push(`/${shortName}/visitor_login`);
    };

    const renderTextLoginRegister = () => {
        const loginRegister = [
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'exhibited.products' }),
                value: eventInfo.has_exhibition && !eventInfo.free_exhibition,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'login.seminars' }),
                value: eventInfo.has_seminar && !eventInfo.free_seminar,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
                value: eventInfo.has_live_stream && !eventInfo.free_live_stream,
            },
        ];
        let count = 0;

        loginRegister.forEach((item) => {
            count = item.value ? count + 1 : count;
        });

        const arrFree = loginRegister.filter((item) => item.value);

        if (count === 1) {
            return intl.formatMessage({ id: 'home.textLoginRegister' }, { loginPage: `${arrFree[0].text}` });
            // return `既に、${arrFree[0].text}へお申込みの方は「申込み済の方はこちら」ボタンよりログインしてください。`;
        }
        if (count === 2) {
            return intl.formatMessage({ id: 'home.textLoginRegister' }, { loginPage: `${arrFree[0].text}`, loginTwoPage: `${arrFree[1].text}` });
            // return `既に、${arrFree[0].text}・${arrFree[1].text}へお申込みの方は「申込み済の方はこちら」ボタンよりログインしてください。`;
        }
    };

    const renderTextLoginNoRegister = () => {
        const loginNoRegister = [
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'userRoutes.organizerListNewName' }),
                value: eventInfo.has_exhibition && !eventInfo.free_exhibition,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'userRouters.seminar' }),
                value: eventInfo.has_seminar && !eventInfo.free_seminar,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }),
                value: eventInfo.has_live_stream && !eventInfo.free_live_stream,
            },
        ];
        let count = 0;

        loginNoRegister.forEach((item) => {
            count = item.value ? count + 1 : count;
        });

        const arrFree = loginNoRegister.filter((item) => item.value);

        if (count === 1) {
            return intl.formatMessage({ id: 'home.textLoginNoRegister' }, { loginPage: `${arrFree[0].text}` });
            // return `まだお申込みされていない方は、左の【${arrFree[0].text}】より、ページ内下部にある「申込みする」ボタンよりお申込みいただけます。`;
        }
        if (count === 2) {
            return intl.formatMessage({ id: 'home.textLoginNoRegisterTwoPage' }, { loginPage: `${arrFree[0].text}`, loginTwoPage: `${arrFree[1].text}` });
            // return `まだお申込みされていない方は、左の【${arrFree[0].text}/${arrFree[1].text}】より、ページ内下部にある「申込みする」ボタンよりお申込みいただけます。`;
        }
    };

    return (
        <GridItem container item className={!eventInfo.outer_server_activation ? classes.sectionWrapper : classes.allCenter}>
            <GridItem xs={12} lg={6} className={classes.sectionLeft}>
                <div className={!eventInfo.outer_server_activation ? classes.centerToRight : classes.flexStart}>
                    <Button
                        color="info"
                        gradient
                        className={classes.buttonBig}
                        round
                        onClick={handleVisitorLogin}
                        buttonTextColor={customColor?.button_text_color}
                        buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.viewer}
                    >
                        { intl.formatMessage({ id: 'home.apply' })}
                    </Button>
                </div>
            </GridItem>
            <GridItem xs={12} lg={6}>
                <Box display="flex">
                    <RadioButtonIcon color={customColor?.button_background_color?.viewer || '#4facfe'} />
                    <Typography className={classes.rightContent} variant="subtitle1" customColor={customColor?.contents_text_color}>
                        {renderTextLoginRegister()}
                    </Typography>
                </Box>
                <Box display="flex">
                    <RadioButtonIcon color={customColor?.button_background_color?.viewer || '#4facfe'} />
                    <Typography className={classes.rightContent} variant="subtitle1" customColor={customColor?.contents_text_color}>
                        {renderTextLoginNoRegister()}
                    </Typography>
                </Box>
            </GridItem>
        </GridItem>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

SeminarLogin.defaultProps = {
    eventInfo: {},
    customColor: {},
};

SeminarLogin.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SeminarLogin);
